var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 0.00822968C23.6435 -0.00274323 23.5362 -0.00274323 23.4297 0.00822968H1.55469C1.41449 0.0103899 1.27522 0.031412 1.14062 0.0707296L12.4297 11.3129L23.75 0.00822968Z",
    fill: "#2E8056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 1.09399L13.5312 12.4221C13.2385 12.7131 12.8425 12.8765 12.4297 12.8765C12.0169 12.8765 11.6209 12.7131 11.3281 12.4221L0.0546875 1.17993C0.0200308 1.30731 0.00165522 1.43856 0 1.57056V17.1956C0 17.61 0.16462 18.0074 0.457646 18.3004C0.750671 18.5934 1.1481 18.7581 1.5625 18.7581H23.4375C23.8519 18.7581 24.2493 18.5934 24.5424 18.3004C24.8354 18.0074 25 17.61 25 17.1956V1.57056C24.9938 1.40779 24.9622 1.24699 24.9062 1.09399ZM2.63281 17.1956H1.54688V16.0784L7.22656 10.4456L8.32812 11.5471L2.63281 17.1956ZM23.4219 17.1956H22.3281L16.6328 11.5471L17.7344 10.4456L23.4141 16.0784L23.4219 17.1956Z",
    fill: "#2E8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.fd4c149af31e46a1198c407a58a96b37.svg";
export { ForwardRef as ReactComponent };